import type { TeamAppModel } from "../../hooks/teamTypes";
import { BattingControls, PlayLog } from "../game/BattingControls";
import { GameScreen } from "../game/GameScreen";

export function GameRoute({ model }: { model: TeamAppModel }) {
  const { shell, defense, game } = model;
  const offenseContent = game.batting ? (
    <BattingControls
      players={game.players}
      battingList={game.battingList}
      bases={game.bases}
      inningRuns={game.ourRunsByInning[game.inning - 1] ?? 0}
      currentRunCap={game.currentRunCap}
      batterIndex={game.batterIndex}
      batter={game.batter}
      nextBatters={game.nextBatters}
      isJerseyBatter={game.isJerseyBatter}
      jerseyCaption={game.jerseyCaption}
      pendingRbi={game.pendingRbi}
      pendingPlay={game.pendingPlay}
      showLegend={game.showLegend}
      gameId={game.gameId}
      actionStatus={game.actionStatus}
      onAdvanceRunner={game.actions.advanceRunner}
      onRemoveRunner={game.actions.removeRunner}
      onApplyRbi={game.actions.applyRBI}
      onSetDecision={game.actions.setDecision}
      onAdjustPendingRbi={game.actions.adjustPendingRbi}
      onApplyPlay={game.actions.submitPlay}
      onCancelPlay={game.actions.cancelPlay}
      onRecordResult={game.actions.selectResult}
      onEndHalfInning={game.actions.endHalf}
      onToggleLegend={() => game.setShowLegend((visible) => !visible)}
    />
  ) : null;
  const playLogContent = (
    <PlayLog
      log={game.log}
      open={game.logOpen}
      onToggle={() => game.setLogOpen((open) => !open)}
    />
  );

  return (
    <GameScreen
      teamName={game.teamName}
      opponentName={game.opponentName}
      isHome={game.isHome}
      inning={game.inning}
      batting={game.batting}
      halfInningTransition={game.halfInningTransition}
      completedHalfInningRuns={game.completedHalfInningRuns}
      outs={game.outs}
      ourScore={game.ourScore}
      opponentScore={game.opponentScore}
      ourRunsByInning={game.ourRunsByInning}
      opponentRunsByInning={game.opponentRunsByInning}
      toast={null}
      gameFinal={game.gameFinal}
      mercyRuleWinner={game.mercyRuleWinner}
      finalLabel={game.finalLabel}
      serverBusy={game.serverBusy}
      gameId={game.gameId}
      actionStatus={game.actionStatus}
      canScore={game.canScore}
      isOpenInning={game.isOpenInning}
      openInning={game.openInning}
      currentRunCap={game.currentRunCap}
      opponentRunCap={game.opponentRunCap}
      pendingRbi={game.pendingRbi}
      offenseContent={offenseContent}
      playLogContent={playLogContent}
      players={game.players}
      preferences={game.preferences}
      defense={game.defense}
      historyLength={game.historyLength}
      undoCrossesHalfInning={game.undoCrossesHalfInning}
      onArchive={game.actions.endAndArchive}
      onForfeit={game.actions.forfeitGame}
      onKeepPlaying={game.actions.keepPlaying}
      onToggleOpenInning={game.actions.toggleOpenInning}
      onAddOpponentRun={game.actions.addOppRun}
      onEndHalfInning={game.actions.endHalf}
      onApplyRbi={game.actions.applyRBI}
      onConfirmHalfInningTransition={game.actions.confirmHalfInningTransition}
      onShowDefense={() => shell.setScreen("defense")}
      onEditDefense={(defenseInning) => {
        defense.setSelectedInning(defenseInning);
        shell.setScreen("defense");
      }}
      onUndo={game.actions.undo}
    />
  );
}
